/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TimePeriodServiceGetUploadFilesResponse
 */
export interface TimePeriodServiceGetUploadFilesResponse {
    /**
     * 
     * @type {string}
     * @memberof TimePeriodServiceGetUploadFilesResponse
     */
    uploadId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TimePeriodServiceGetUploadFilesResponse
     */
    fileId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TimePeriodServiceGetUploadFilesResponse
     */
    fileName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TimePeriodServiceGetUploadFilesResponse
     */
    fileSizeBytes?: number;
    /**
     * 
     * @type {string}
     * @memberof TimePeriodServiceGetUploadFilesResponse
     */
    status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TimePeriodServiceGetUploadFilesResponse
     */
    fileType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TimePeriodServiceGetUploadFilesResponse
     */
    createdBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TimePeriodServiceGetUploadFilesResponse
     */
    createdDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof TimePeriodServiceGetUploadFilesResponse
     */
    appliedBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TimePeriodServiceGetUploadFilesResponse
     */
    appliedDate?: Date;
}

/**
 * Check if a given object implements the TimePeriodServiceGetUploadFilesResponse interface.
 */
export function instanceOfTimePeriodServiceGetUploadFilesResponse(value: object): value is TimePeriodServiceGetUploadFilesResponse {
    return true;
}

export function TimePeriodServiceGetUploadFilesResponseFromJSON(json: any): TimePeriodServiceGetUploadFilesResponse {
    return TimePeriodServiceGetUploadFilesResponseFromJSONTyped(json, false);
}

export function TimePeriodServiceGetUploadFilesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimePeriodServiceGetUploadFilesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'uploadId': json['uploadId'] == null ? undefined : json['uploadId'],
        'fileId': json['fileId'] == null ? undefined : json['fileId'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'fileSizeBytes': json['fileSizeBytes'] == null ? undefined : json['fileSizeBytes'],
        'status': json['status'] == null ? undefined : json['status'],
        'fileType': json['fileType'] == null ? undefined : json['fileType'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'appliedBy': json['appliedBy'] == null ? undefined : json['appliedBy'],
        'appliedDate': json['appliedDate'] == null ? undefined : (new Date(json['appliedDate'])),
    };
}

export function TimePeriodServiceGetUploadFilesResponseToJSON(json: any): TimePeriodServiceGetUploadFilesResponse {
    return TimePeriodServiceGetUploadFilesResponseToJSONTyped(json, false);
}

export function TimePeriodServiceGetUploadFilesResponseToJSONTyped(value?: TimePeriodServiceGetUploadFilesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uploadId': value['uploadId'],
        'fileId': value['fileId'],
        'fileName': value['fileName'],
        'fileSizeBytes': value['fileSizeBytes'],
        'status': value['status'],
        'fileType': value['fileType'],
        'createdBy': value['createdBy'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'appliedBy': value['appliedBy'],
        'appliedDate': value['appliedDate'] == null ? undefined : ((value['appliedDate']).toISOString()),
    };
}

